export default "__VITE_ASSET__Bqn5dlAJ__"